import { GET_MAQUINAS_CENTRO_ORIGEN, MOVE_MAQUINA_TO_CENTRO_DESINO } from '../constants/action_types';

const initialState = { maquinas: [], refresh: false, isLoading: false };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_MAQUINAS_CENTRO_ORIGEN:

        return { maquinas: [], refresh: false, isLoading: true };
        
        case GET_MAQUINAS_CENTRO_ORIGEN + "_SUCCESS":
        
            return { maquinas: action.payload.data, refresh: false, isLoading: false };

        case MOVE_MAQUINA_TO_CENTRO_DESINO + "_SUCCESS":

            return { maquinas: action.payload.data, refresh: true, isLoading: false };

        default:

            return state;
    };

};